import React from 'react';
import NewtonsCradleLoader from '../common/NewtonsCradleLoader';

const AppLoader = ({ size = '32px', color, className = '' }) => (
  <div className={`module-loader ${className}`}>
    <NewtonsCradleLoader size={size} color={color} />
  </div>
);

export default AppLoader;
